package diagnosis.container


import com.jingfangpai.api.clients.DiagnosisApiClient
import com.jingfangpai.api.clients.MedicalRecordApiClient
import com.jingfangpai.api.clients.SignSymptomApiClient
import com.jingfangpai.common.data.model.CascadedOption
import com.jingfangpai.common.data.response.ApiResponse
import diagnosis.component.Diagnosis
import react.*
import react.dom.div
import setTitle

external interface DiagnosisPageProps : RProps {
  var medicalRecordId:String
}

data class DiagnosisPageContextData(
    var getMedicalRecordAndDiagnosis:(medicalRecordId:kotlin.String, okCallback: (result:com.jingfangpai.common.data.response.ApiResponse<com.jingfangpai.medicalRecord.model.MedicalRecordAndDiagnosis>) -> Unit, errorCallback: (exception:Throwable) -> Unit) -> Unit,
    var generateDiagnosis:(medicalRecordId:kotlin.String, okCallback: (result:com.jingfangpai.common.data.response.ApiResponse<kotlin.Array<com.jingfangpai.medicalRecord.model.MedicalRecordDiagnosisSuggestionDto>>) -> Unit, errorCallback: (exception:Throwable) -> Unit)->Unit,
    var getSignSymptomOptions:(okCallback: (result: ApiResponse<Array<CascadedOption<String>>>) -> Unit, errorCallback: (exception:Throwable) -> Unit) -> Unit,
    var saveSignSymptom:(medicalRecordSignSymptom:com.jingfangpai.common.orm.mapping.MedicalRecordSignSymptom, okCallback: (result:com.jingfangpai.common.data.response.ApiResponse<com.jingfangpai.common.orm.mapping.MedicalRecordSignSymptom>) -> Unit, errorCallback: (exception:Throwable) -> Unit)->Unit
)

val DiagnosisPageContext = createContext(DiagnosisPageContextData(DiagnosisApiClient::getMedicalRecordAndDiagnosis,DiagnosisApiClient::generateDiagnosis,
    SignSymptomApiClient::getOptions,MedicalRecordApiClient::saveSignSymptom))

val DiagnosisPageProvider = functionalComponent<DiagnosisPageProps> { props ->

    setTitle("病案诊断")

    fun placeHolderFunction(param: String) {
        console.log("doing something with param")
    }

    useEffectOnce { }

    DiagnosisPageContext.Provider(DiagnosisPageContextData(DiagnosisApiClient::getMedicalRecordAndDiagnosis,DiagnosisApiClient::generateDiagnosis,SignSymptomApiClient::getOptions,
        MedicalRecordApiClient::saveSignSymptom)) {
        div("Diagnosis-page") {
            child(Diagnosis) {
                attrs{
                    medicalRecordId = props.medicalRecordId
                }
            }
        }
    }
}
